import { TextInputMasked } from '@perpay-web/components/base/TextInputMasked/TextInputMasked';
import { withFormServerErrors } from '@perpay-web/components/higher-order/WithFieldServerErrors/WithFormServerErrors';

const TextInputMaskedServerError = withFormServerErrors(TextInputMasked);

export default TextInputMaskedServerError;
